import React from "react";
import { Box, Button, Card, CardMedia, Typography, Grid, Divider, Avatar, List, ListItem, ListItemText, Rating, IconButton } from "@mui/material";
import InstallButton from "@mui/icons-material/Download"; // Icon for download button
import SearchIcon from "@mui/icons-material/Search";
import HelpOutline from "@mui/icons-material/HelpOutline";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import logo from "../assets/googlepay.svg";


function NavHeader() {
 return (
  <header className="header header-shadow">
  <Box display="flex" alignItems="center" justifyContent="space-between"  height={56}>
  <div className="f0UV3d">
    <img src={logo} className="google-pay-icon w-[40px] mr-[8px]" />
    <span className="" aria-hidden="true">google_logo Play</span>
  </div>
  <div className="flex">
    <IconButton size="large">
      <SearchIcon />
    </IconButton>
    <IconButton size="large">
      <HelpOutline />
    </IconButton>
    <IconButton size="large" className="mr-[8px]">
    <CardMedia className="" component="img" image="https://fonts.gstatic.com/s/i/productlogos/avatar_anonymous/v4/web-32dp/logo_avatar_anonymous_color_1x_web_32dp.png" />
    </IconButton>
  </div>
</Box>
</header>
 )
}
export default NavHeader

